import {
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import {
  FitnessWorkoutTypesList,
  RunWorkoutTypesList,
  SwimWorkoutTypesList,
  WorkoutCategories,
  WorkoutCategoriesList,
} from "@readyfit-common/models";
import { FormikErrors } from "formik";
import { WorkoutFormValues } from "../EditWorkoutModal/EditWorkoutModal";
import FitnessWorkoutForm from "./FitnessWorkoutForm";
import RunWorkoutForm from "./RunWorkoutForm";
import SwimWorkoutForm from "./SwimWorkoutForm";
import useStyles from "./WorkoutForm.style";

interface WorkoutFormProps {
  values: WorkoutFormValues;
  errors: FormikErrors<WorkoutFormValues>;
  handleChange: any;
  setFieldValue: any;
}

const WorkoutForm = ({
  values,
  errors,
  handleChange,
  setFieldValue,
}: WorkoutFormProps) => {
  const classes = useStyles();

  const renderWorkoutForm = () => {
    switch (values.workoutCategoryId) {
      case WorkoutCategories.RUN:
        return (
          <RunWorkoutForm
            values={values}
            errors={errors}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
          />
        );

      case WorkoutCategories.FITNESS:
        return (
          <FitnessWorkoutForm
            values={values}
            errors={errors}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
          />
        );

      case WorkoutCategories.SWIM:
        return (
          <SwimWorkoutForm
            values={values}
            errors={errors}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
          />
        );
      default:
        return null;
    }
  };

  const workoutTypesMap = {
    [WorkoutCategories.RUN]: RunWorkoutTypesList,
    [WorkoutCategories.SWIM]: SwimWorkoutTypesList,
    [WorkoutCategories.FITNESS]: FitnessWorkoutTypesList,
  };

  return (
    <Grid container rowGap={3}>
      <Grid xs={12}>
        <InputLabel htmlFor="name" className={classes.inputLabel}>
          <Typography variant="subtitle1">Name</Typography>
        </InputLabel>
        <TextField
          fullWidth
          variant="outlined"
          value={values.name}
          placeholder="Name"
          InputProps={{
            className: classes.input,
          }}
          onChange={handleChange("name")}
          error={!!errors.name}
          helperText={errors.name}
        />
      </Grid>

      <Grid xs={12}>
        <InputLabel htmlFor="name" className={classes.inputLabel}>
          <Typography variant="subtitle1">Workout</Typography>
        </InputLabel>
        <Select
          fullWidth
          variant="outlined"
          value={values.workoutCategoryId || ""}
          className={classes.input}
          onChange={(e) => {
            setFieldValue("workoutCategoryId", e.target.value);
            setFieldValue("workoutTypeId", "");
          }}
          error={!!errors.workoutCategoryId}
        >
          {WorkoutCategoriesList.map((category) => (
            <MenuItem key={category.id} value={category.id}>
              {category.name}
            </MenuItem>
          ))}
        </Select>
        {errors.workoutCategoryId && (
          <FormHelperText error sx={{ marginLeft: "14px" }}>
            {errors.workoutCategoryId}
          </FormHelperText>
        )}
      </Grid>

      <Grid xs={12}>
        <InputLabel htmlFor="name" className={classes.inputLabel}>
          <Typography variant="subtitle1">Type</Typography>
        </InputLabel>
        <Select
          fullWidth
          variant="outlined"
          value={values.workoutTypeId || ""}
          placeholder="Name"
          className={classes.input}
          onChange={(e) => setFieldValue("workoutTypeId", e.target.value)}
          disabled={!values.workoutCategoryId}
          error={!!errors.workoutTypeId}
        >
          {workoutTypesMap[values.workoutCategoryId as WorkoutCategories]?.map(
            (type) => (
              <MenuItem key={type.id} value={type.id}>
                {type.name}
              </MenuItem>
            ),
          )}
        </Select>
        {errors.workoutTypeId && (
          <FormHelperText sx={{ marginLeft: "14px" }} error>
            {errors.workoutTypeId}
          </FormHelperText>
        )}
      </Grid>

      {renderWorkoutForm()}
    </Grid>
  );
};

export default WorkoutForm;
